import React from 'react';
import './LoadingOverlay.scss';
import LoadingSpinner from './LoadingSpinner';

const LoadingOverlay = ({ loading, children, minHeight }) => {
    const containerStyle = minHeight ? { minHeight } : undefined;
    return (
        <div className="loading-overlay-container" style={containerStyle}>
            {children}
            {loading && (
                <div className="loading-overlay">
                    <div className="loading-content">
                        <LoadingSpinner size="2rem" />
                    </div>
                </div>
            )}
        </div>
    );
};

export default LoadingOverlay;
